import React from "react"
import Cs from "../../services/CommonService";

const checkJsonOrHtml = (html) =>{
  if(!html) return '';
  
  if (typeof html === 'string') {
    return html;
  }else if(typeof html === 'object'){
    return Cs.editorJSToHtml(html);
  }
}

const SpanRichTextView = ({html, className, style}) => {
  return (
    <span className={className} style={style} dangerouslySetInnerHTML={{ __html: checkJsonOrHtml(html) }}></span>
  )
}

const DivRichTextView = ({html, className, style}) => {
  return (
    <div className={className} style={style} dangerouslySetInnerHTML={{ __html: checkJsonOrHtml(html) }}></div>
  )
}

const ParaRichTextView = ({html, className, style}) => {
  return (
    <div className={className} style={style} dangerouslySetInnerHTML={{ __html: checkJsonOrHtml(html) }}></div>
  )
}

const LabelRichTextView = ({html, className, style}) => {
  return (
    <div className={className} style={style} dangerouslySetInnerHTML={{ __html: checkJsonOrHtml(html) }}></div>
  )
}

export {SpanRichTextView, DivRichTextView,ParaRichTextView,LabelRichTextView};